/**
 * Best Practice Protected Route
 * Waits for auth initialization before checking auth state
 */

import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const ProtectedRoute = React.memo(({ children, allowedRoles }) => {
  const { userType, isAuthenticated, isInitialized } = useUser();
  const location = useLocation();

  // Memoize the redirect state to prevent unnecessary re-renders
  const redirectState = useMemo(() => ({
    from: location.pathname
  }), [location.pathname]);

  // Wait for auth initialization - show loading only if we're still checking auth
  // If initialized and not authenticated, redirect immediately (no loading)
  if (!isInitialized) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f8f9fa'
      }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Check authentication and authorization
  // If initialized and not authenticated, redirect to login immediately
  if (!isAuthenticated || (allowedRoles && !allowedRoles.includes(userType))) {
    return <Navigate to="/login" state={redirectState} replace />;
  }

  return <>{children}</>;
});

ProtectedRoute.displayName = 'ProtectedRoute';

export default ProtectedRoute;
